import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const ResidentialSympathySavingsStepPage = () => {
  return (
    <>
      <div className={stepStyles.wearDescription}>
        Upload photos or documents that show sympathy and savings of your property. This helps
        demonstrate a decrease in taxable value. This is an optional step and can be skipped if you
        do not have any sympathy or savings to upload.
      </div>

      <div className={stepStyles.wearExamplesCard}>
        <div className={stepStyles.wearExamplesTitle}>Examples of what to upload:</div>
        <ul className={stepStyles.wearExamplesList}>
          <li>Photos of damaged areas</li>
          <li>Repair estimates</li>
          <li>Inspection reports</li>
          <li>Maintenance issues documentation</li>
        </ul>
      </div>
    </>
  );
};
